<template>
	<section class="newsletter background-light">
		<div class="row align-center">
			<div class="columns column12">
				<h2>{{ header }}</h2>
				<div v-parse-links v-html="content" />

				<!-- Begin Mailchimp Signup Form -->
				<div id="mc_embed_signup">
					<form
						id="mc-embedded-subscribe-form"
						action="https://hotelkint.us20.list-manage.com/subscribe/post?u=b521529c4c6438a654a58038b&amp;id=17a68eafe6&amp;f_id=00b70ae7f0%22"
						method="post"
						name="mc-embedded-subscribe-form"
						class="validate newsletter"
						target="_blank"
						novalidate
					>
						<div id="mc_embed_signup_scroll">
							<div class="mc-field-group newsletter-form">
								<input
									id="mce-EMAIL"
									type="email"
									value=""
									name="EMAIL"
									class="required email"
									:placeholder="$t('formEmail')"
								/>
								<input
									id="mc-embedded-subscribe"
									type="submit"
									name="subscribe"
									class="button"
									:value="button"
								/>
							</div>
							<div>
								<div id="mce-responses" class="clear">
									<div id="mce-error-response" class="response" style="display: none" />
									<div id="mce-success-response" class="response" style="display: none" />
								</div>
								<!-- real people should not fill this in - do not remove this or risk bot signups-->
								<div style="position: absolute; left: -5000px" aria-hidden="true">
									<input
										type="text"
										name="b_b521529c4c6438a654a58038b_17a68eafe6"
										tabindex="-1"
										value=""
									/>
								</div>
							</div>
						</div>
					</form>
				</div>
				<!-- end Mailchimp Signup Form -->
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.newsletter {
	p {
		max-width: 600px;
		margin: 0 auto 20px;
	}

	input {
		appearance: none;
	}

	input:not(.button) {
		border: none;
		width: 280px;
		padding: 0 10px;
		line-height: 50px;
		outline: none !important;
		font-family: var(--body-font-family);
		font-size: var(--body-font-size);
	}

	.button {
		border: none;
		margin: 0;
		cursor: pointer;
		outline: none;
	}
}

.package-subpage section.newsletter {
	padding: 50px 0;
}

section.newsletter {
	padding: 50px 0 0;
}

form.newsletter {
	background: none;
	padding: 10px 0;
	display: inline-block;
	margin: 20px auto 50px;
	border-bottom: 1px solid #000;

	input {
		background: none;
		padding: 0;
		color: #000;

		&::placeholder {
			color: #000;
		}

		&.button {
			background: var(--cta-color);
			padding: 10px 25px;
			color: #fff;
		}
	}
}

@media (max-width: 680px) {
	.newsletter input {
		width: 100%;
		text-align: center;
	}
}
</style>
